export default __webpack_public_path__ + "static/media/Homemade_pizza.88d96624.jpg";